import React, {useEffect} from "react";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {SessionState} from "../../../services/store/reducers/session/slice";
import {useNavigate} from "react-router-dom";
import {buildUrl, PLATFORM_HOME} from "../../../services/PageUtils";

interface Props {
}

export const Loading = ({}: Props) => {

    const { sessionState } = handicaddieSelector((state) => state.session)
    const nav = useNavigate();

    useEffect(() => {
        if (sessionState === SessionState.ACTIVE) {
            nav(buildUrl(PLATFORM_HOME))
        }
    }, [sessionState])

    return <>
        <div
            className={"contentContainer"}
            style={{
                height: "calc(100vh - 76px)",
                marginTop: "0px",
            }}
        >
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        minWidth: "50%",
                        width: "auto",
                        height: "auto",
                        padding: "10px",
                        backgroundColor: "white",
                        borderRadius: "10px",
                    }}
                >
                    <img
                        src={"./logo.svg"}
                        className="card_menu_img"
                        style={{ margin: "auto", height: "100px" }}
                    />
                    <div style={{display: 'flex', padding: '5em', justifyContent: 'center'}}>
                        {/*<Spinner animation="border" />*/}
                    </div>
                </div>
            </div>
        </div>
    </>
}